import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { useUserRole } from './useUserRole';
import { useUserRoles } from './useUserRoles';
import { getLiberiaMyPermissions, isLiberiaApiEnabled } from '@/utils/liberiaApi';

export const useAddressGenerationAccess = () => {
  const { user } = useAuth();
  const { role } = useUserRole();
  const { data: roleAccess = [] } = useUserRoles();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      if (!user || !isLiberiaApiEnabled()) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      const roleNames = new Set([role, ...roleAccess.map((entry) => entry.role)].filter(Boolean));
      if (roleNames.has('admin') || roleNames.has('partner')) {
        setHasAccess(true);
        setLoading(false);
        return;
      }

      try {
        const data = await getLiberiaMyPermissions({
          user,
          role,
          hasAddressGenerationAccess: false,
        });

        setHasAccess(Array.isArray(data.permissions) && data.permissions.includes('address_generation:create'));
      } catch (error) {
        console.error('Error checking address generation access:', error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    void checkAccess();
  }, [role, roleAccess, user]);

  return { hasAccess, loading };
};
